import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  main: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    background:
      'linear-gradient(145deg, #F4F6F9 0%, #EEF2F6 60%, #EAF0F5 100%)',
  },
  appBarSpacer: theme.mixins.toolbar,
  childrenContainer: {
    zIndex: 10,
  },
}));
